// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3PSRO","productName":"Table_productName__8kZBM"};